 export default [
 	{
 		name:'保护中心',
 		nums:2,
 		childs:['中国（合肥）知识产权保护中心','中国（安徽）知识产权保护中心（筹建中）'],
 	},{
 		name:'专利导航服务基地',
 		nums:'1+10',
 		childs:[
 			'中国安徽专利导航服务基地',
 			'合肥市（先进环保设备）专利导航服务基地',
 			'蚌埠市（硅基新材料）专利导航服务基地',
 			'阜阳市（节能环保）专利导航服务基地',
 			'淮北市（陶铝新材料）专利导航服务基地',
 			'滁州市（凹凸棒基新材料）专利导航服务基地',
 			'铜陵市（铜基新材料）专利导航服务基地',
 			'芜湖市（新能源汽车）专利导航服务基地',
 			'池州市（半导体）专利导航服务基地',
 			'安庆市（化工新材料）专利导航服务基地',
 			'淮南市（高端装备制造）专利导航服务基地'],
 	},{
 		name:'维权援助中心',
 		nums:'1+16',
 		childs:[
 			'中国（安徽）知识产权维权援助中心',
 			'中国（安徽）知识产权维权援助中心合肥分中心',
 			'中国（安徽）知识产权维权援助中心淮北分中心',
 			'中国（安徽）知识产权维权援助中心亳州分中心',
 			'中国（安徽）知识产权维权援助中心宿州分中心',
 			'中国（安徽）知识产权维权援助中心蚌埠分中心',
 			'中国（安徽）知识产权维权援助中心阜阳分中心',
 			'中国（安徽）知识产权维权援助中心淮南分中心',
 			'中国（安徽）知识产权维权援助中心滁州分中心',
 			'中国（安徽）知识产权维权援助中心六安分中心',
 			'中国（安徽）知识产权维权援助中心马鞍山分中心',
 			'中国（安徽）知识产权维权援助中心芜湖分中心',
 			'中国（安徽）知识产权维权援助中心宣城分中心',
 			'中国（安徽）知识产权维权援助中心铜陵分中心',
 			'中国（安徽）知识产权维权援助中心池州分中心',
 			'中国（安徽）知识产权维权援助中心安庆分中心',
 			'中国（安徽）知识产权维权援助中心黄山分中心',],
 	},{
 		name:'人民调解委员会',
 		nums:146,
 		childs:[
			'中国（安徽）自由贸易试验区合肥片区知识产权纠纷人民调解委员会',
			'合肥市瑶海区龙岗开发区知识产权保护维权服务站',
			'合肥新站高新技术产业开发区知识产权保护维权服务站',
			'合肥市庐阳经开区知识产权保护维权服务站',
			'合肥蜀山经济开发区知识产权保护维权服务站',
			'合肥高新技术产业开发区柏堰知识产权保护维权服务站',
			'肥西经开区知识产权保护维权服务站',
			'肥东经开区知识产权保护维权服务站',
			'安巢经开区知识产权保护维权服务站',
			'瑶海区知识产权纠纷人民调解委员会',
			'肥东县知识产权纠纷人民调解委员会',
			'肥西县知识产权纠纷人民调解委员会',
			'长丰县知识产权纠纷人民调解委员会',
			'庐江县知识产权纠纷人民调解委员会',
			'中国（安徽）自由贸易试验区蜀山区块知识产权纠纷人民调解委员会',
			'包河区知识产权纠纷人民调解委员会',
			'淮北市知识产权纠纷人民调解委员会',
			'濉溪县市场监督管理局知识产权纠纷人民调解委员会',
			'相山区市场监督管理局知识产权纠纷人民调解委员会',
			'杜集区市场监督管理局知识产权纠纷人民调解委员会',
			'烈山区知识产权纠纷人民调解委员会',
			'淮北高新区市场监督管理局人民调解委员会',
			'亳州市知识产权纠纷人民调解委员会',
			'亳州市知识产权纠纷人民调解委员会利辛工作室',
			'蒙城县知识产权纠纷人民调解委员会',
			'涡阳县知识产权纠纷人民调解委员会',
			'谯城区知识产权纠纷人民调解委员会',
			'利辛县知识产权纠纷人民调解委员会',
			'宿州市知识产权纠纷人民调解委员会',
			'埇桥区知识产权纠纷人民调解委员会',
			'萧县知识产权纠纷人民调解委员会',
			'砀山县知识产权纠纷人民调解委员会',
			'泗县知识产权纠纷人民调解委员会',
			'灵璧县知识产权纠纷人民调解委员会',
			'蚌埠市知识产权纠纷人民调解委员会',
			'怀远县知识产权纠纷人民调解委员会',
			'五河县知识产权纠纷人民调解委员会',
			'固镇县知识产权纠纷人民调解委员会',
			'阜阳市知识产权纠纷人民调解委员会',
			'太和县知识产权纠纷人民调解委员会',
			'阜南县知识产权纠纷人民调解委员会',
			'颍泉区知识产权纠纷人民调解委员会',
			'颍上县知识产权纠纷人民调解委员会',
			'颍东区知识产权纠纷人民调解委员会',
			'界首市知识产权纠纷人民调解委员会',
			'临泉县知识产权纠纷人民调解委员会',
			'颍州区知识产权纠纷人民调解委员会',
			'淮南市知识产权纠纷调解委员会',
			'寿县知识产权纠纷人民调解委员会',
			'淮南市高新区知识产权纠纷人民调解委员会',
			'滁州市知识产权纠纷人民调解委员会',
			'来安县知识产权维权援助工作站',
			'全椒县知识产权维权援助工作站',
			'天长市知识产权维权援助工作站',
			'明光市知识产权维权援助工作站',
			'定远县知识产权维权援助工作站',
			'凤阳县知识产权维权援助工作站',
			'琅琊区知识产权维权援助工作站',
			'南谯区知识产权维权援助工作站',
			'南谯区知识产权纠纷人民调解委员会',
			'琅琊区知识产权纠纷人民调解委员会',
			'天长市知识产权纠纷人民调解委员会',
			'明光市知识产权纠纷人民调解委员会',
			'来安县知识产权纠纷人民调解委员会',
			'全椒县知识产权纠纷人民调解委员会',
			'凤阳县知识产权纠纷人民调解委员会',
			'定远县知识产权纠纷人民调解委员会',
			'六安市知识产权纠纷人民调解委员会',
			'霍山县知识产权调解工作室',
			'六安市叶集区知识产权纠纷人民调解委员会',
			'六安市知识产权纠纷人民调解委员会裕安调解工作室',
			'六安市知识产权纠纷人民调解委员会霍邱调解工作室',
			'六安市经济技术开发区知识产权纠纷人民调解委员会',
			'六安市知识产权纠纷人民调解委员会金寨调解工作室',
			'六安市金安区知识产权纠纷人民调解委员会',
			'舒城县知识产权纠纷人民调解委员会',
			'马鞍山市知识产权纠纷人民调解委员会',
			'马鞍山市知识产权维权援助中心含山县分中心',
			'马鞍山市知识产权维权援助中心和县分中心',
			'马鞍山市知识产权维权援助中心当涂县分中心',
			'马鞍山市知识产权维权援助中心花山区分中心',
			'马鞍山市知识产权维权援助中心雨山区分中心',
			'马鞍山市知识产权维权援助中心博望区分中心',
			'马鞍山市知识产权维权援助中心市经济技术开发区分中心',
			'马鞍山市知识产权维权援助中心慈湖高新技术产业开发区分中心',
			'马鞍山市知识产权维权援助中心郑蒲港新区现代产业园区分中心',
			'芜湖市知识产权纠纷人民调解委员会',
			'镜湖区知识产权纠纷人民调解委员会',
			'弋江区知识产权纠纷人民调解委员会',
			'鸠江区知识产权纠纷人民调解委员会',
			'湾沚区知识产权纠纷人民调解委员会',
			'繁昌区知识产权纠纷人民调解委员会',
			'无为市知识产权纠纷人民调解委员会',
			'南陵县知识产权纠纷人民调解委员会',
			'经济技术开发区知识产权纠纷人民调解委员会',
			'三山经开区知识产权纠纷人民调解委员会',
			'安徽自贸试验区芜湖片区知识产权纠纷人民调解委员会',
			'宣城市知识产权纠纷人民调解委员会',
			'宣城经开区知识产权纠纷人民调解委员会',
			'宣州区知识产权纠纷人民调解委员会',
			'郎溪县知识产权纠纷人民调解委员会',
			'广德市知识产权纠纷人民调解委员会',
			'宁国市知识产权纠纷人民调解委员会',
			'绩溪县知识产权纠纷人民调解委员会',
			'旌德县知识产权纠纷人民调解委员会',
			'泾县知识产权纠纷人民调解委员会',
			'铜陵市知识产权纠纷人民调解委员会',
			'枞阳县知识产权纠纷人民调解委员会',
			'铜陵市铜官区知识产权纠纷人民调解委员会',
			'铜陵市义安区知识产权纠纷人民调解委员会',
			'铜陵市郊区知识产权纠纷人民调解委员会',
			'池州市知识产权纠纷人民调解委员会',
			'池州市贵池区知识产权纠纷人民调解委员会',
			'东至县知识产权纠纷人民调解委员会',
			'石台县知识产权纠纷人民调解委员会',
		],
 	},{
 		name:'技术与创新支持中心',
 		nums:3,
 		childs:[
 			'合肥汇众知识产权管理有限公司',
 			'中国科学技术大学',
 			'安徽信息工程学院（筹）',
 		],
 	},{
 		name:'信息公共服务网点',
 		nums:55,
 		childs:[
 			'中国科学技术大学',
 			'合肥汇众知识产权管理有限公司',
 			'安徽浩智信知识产权代理有限公司',
 			'安徽飞镖知识产权服务股份有限公司',
 			'合肥市神州商标事务有限公司',
 			'安徽知问律师事务所',
 			'淮北知创风信息科技有限公司',
 			'蒙城县弘文信息科技有限公司',
 			'宿州智海知识产权代理事务所',
 			'安徽东鹏知识产权运营有限公司',
 			'阜阳师范大学',
 			'安徽冠东电子科技有限公司',
 			'滁州大学科技园有限公司',
 			'六安皖智知识产权运营有限公司',
 			'安徽工业大学',
 			'安徽信息工程学院',
 			'芜湖安汇知识产权代理有限公司',
 			'安徽师范大学',
 			'芜湖皖江知识产权运营中心有限公司',
 			'宣城市生产力促进中心',
 			'铜陵市天成专利事务所',
 			'安徽华鼎知识产权服务有限公司',
 			'安庆师范大学知识产权信息服务中心',
 			'中国（合肥）知识产权保护中心',
 			'安徽佰腾智慧信息技术有限公司',
 			'安徽国之城资产评估有限公司',
 			'合肥超保通知识产权代理有限公司',
 			'龙图腾网科技（合肥）股份有限公司',
 			'合肥市长远专利代理事务所',
 			'淮北市宇控信息技术有限公司',
 			'亳州学院',
 			'安徽弘图致胜知识产权服务有限公司',
 			'涡阳县量子信息科技有限公司',
 			'宿州市万硕云知识产权代理事务所',
 			'蚌埠鼎力专利商标事务所有限公司',
 			'安徽中商知识产权代理有限公司',
 			'安徽金邦商标事务有限公司',
 			'滁州政通中小企业服务中心有限公司',
 			'滁州市启迪之星科技企业孵化器有限公司',
 			'金安经济开发区知识产权信息服务中心',
 			'马鞍山智聚信息科技有限公司',
 			'哈尔滨工业大学芜湖机器人产业技术研究院',
 			'安徽科创生产力促进中心有限公司',
 			'安徽华普生产力促进中心有限公司',
 			'安徽省春谷3D打印智能装备产业技术研究院有限公司',
 			'芜湖思科知识产权咨询有限公司',
 			'芜湖易泽中小企业公共服务股份有限公司',
 			'宁国市知识产权公共服务平台（安徽宁科中小企业管理咨询有限公司）',
 			'铜陵市知识产权协会',
 			'池州市贵池区生产力促进中心',
 			'安庆北大化科技园有限公司（北京化工大学安庆研究院）',
 			'安庆市经济技术开发区新能源汽车产业商会',
 			'安庆启核知识产权信息服务中心',
 			'黄山禾信知识产权代理有限公司',
 			'安徽黄山太平经济开发区管理委员会经贸发展服务中心',
 		],
 	},{
 		name:'海外纠纷应对指导中心',
 		nums:'1+8',
 		childs:[
			"国家海外知识产权纠纷应对指导中心安徽分中心",
			"国家海外知识产权纠纷应对指导中心安徽分中心宿州工作站",
			"国家海外知识产权纠纷应对指导中心安徽分中心滁州工作站",
			"国家海外知识产权纠纷应对指导中心安徽分中心马鞍山工作站",
			"国家海外知识产权纠纷应对指导中心安徽分中心芜湖工作站",
			"国家海外知识产权纠纷应对指导中心安徽分中心池州工作站",
			"国家海外知识产权纠纷应对指导中心安徽分中心黄山工作站",
			"国家海外知识产权纠纷应对指导中心安徽自贸区合肥片区工作站",
		]
 	},
 ]